import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {fetchArticles} from '../../reducer/article-reducer';
import ItemListaArticulo from '../../components/itemListaArticulo';
import {Col, Container, Row} from 'reactstrap';
import '../../sass/article.scss';
interface configObject {
  user: {
    token: string;
  };
  articles: {
    articles: [];
  };
}

interface propiedades {
  fetchArticles(token: string): any;
  token: string;
  articles: [];
}

const ListadoDeArticulos = (props: propiedades) => {
  const {fetchArticles, token, articles} = props;
  useEffect(() => {
    if (token !== '' && articles === null) {
      fetchArticles(token);
    }
  }, [fetchArticles, token, articles]);

  return (
    <div className="listado-articulos">
      <Container>
        <Row>
          <Col>
            {!articles && <div className="lds-dual-ring"></div>}
            {articles?.map((article, index) => {
              return <ItemListaArticulo articulo={article} key={index} />;
            })}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    token: state.user.token,
    articles: state.articles.articles,
  };
};
export default connect(mapStateToProps, {fetchArticles})(ListadoDeArticulos);
